/**
 * Add to cart AJAX
 *
 * @author Dejan Strancar
 */

(function (window, document, $) {
  "use strict";

  $(function () {
    $('a.add-to-card').each(function () {
      $(this).click(function (e) {
        e.preventDefault();
        $.post('/cart/add.js', {
          quantity: 1,
          id: $(this).data('productid')
        })
        .done(function (data) {
          $('.messages > .container').html('Product added to cart!');
          $('.messages').show();

          setTimeout(function () {
            $('.messages').fadeOut("slow", function () {
              $(this).css({display: "none"});
            });
          }, 2000);

          $.get('/cart.js', function (data) {
            data = JSON.parse(data);
            $('.cart-items-number').html(data.item_count);
          });
        })
        .fail(function (data) {
          var response = JSON.parse(data.responseText);
          $('.messages > .container').html(response.description);
          $('.messages').show();

          setTimeout(function () {
            $('.messages').fadeOut("slow", function () {
              $(this).css({display: "none"});
            });
          }, 2000);
        });
      });
    });
  });

}(window, document, jQuery));
